import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { UserService } from '@inera/common';
import { IDHeaderModule } from '@inera/ids-angular/components/header';
import { IDIconUserModule } from '@inera/ids-angular/icons/user';
import { filter, Subject, takeUntil } from 'rxjs';
import { DefaultRouteGuard } from 'src/app/security/default-route-guard.service';
import { IDMobileMenuModule } from '@inera/ids-angular/components/mobile/menu';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [IDHeaderModule, RouterModule, CommonModule, IDIconUserModule, IDMobileMenuModule],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss',
})
export class AppHeaderComponent implements OnInit {
  private destroy$ = new Subject<boolean>();

  public loggedIn = false;
  public isMobileMenuOpen = false;

  private currentPath: string = '';

  constructor(
    private userService: UserService,
    private router: Router,
    private routeGuard: DefaultRouteGuard
  ) {}

  ngOnInit(): void {
    this.userService.connect().subscribe(user => {
      if (user) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
      this.updateNavItems();
    });

    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(e => {
        this.currentPath = (e as NavigationEnd).url;
        this.updateNavItems();
      });
  }

  updateNavItems(): void {
    this.navItems = [
      {
        link: {
          label: 'Validering',
          route: 'validator/employeeplus',
        },
        active: this.currentPath.toLowerCase().includes('validator'),
      },
    ];

    if (this.loggedIn) {
      if (this.routeGuard.checkIfAuthorizedWithRoles(['ADMIN', 'CUSTOMER'])) {
        this.navItems.push(
          {
            link: {
              label: 'Tema',
              route: 'theme',
            },
            active: this.currentPath.toLowerCase().includes('theme'),
          },
          {
            link: {
              label: 'Klientregistrering',
              route: 'client-register',
            },
            active: this.currentPath.toLowerCase().includes('client-register'),
          }
        );
      }
      this.navItems.push({
        link: {
          label: 'SSO-Grupper',
          route: 'sso-groups',
        },
        active: this.currentPath.toLowerCase().includes('sso-groups'),
      });

      if (this.routeGuard.checkIfAuthorizedWithRoles(['ADMIN'])) {
        this.navItems.push({
          link: {
            label: 'Behörigheter',
            route: 'privilege',
          },
          active: this.currentPath.toLowerCase().includes('privilege'),
        });
      }
    }
  }

  public navItems: NavItem[] = [
    {
      link: {
        label: 'Temabyggare',
        route: 'theme-builder',
      },
      active: false,
    },
    {
      link: {
        label: 'Validering',
        route: 'validator',
      },
      active: false,
    },
    {
      link: {
        label: 'Klientregistrering',
        route: 'client-register',
      },
      active: false,
    },
    {
      link: {
        label: 'SSO-Grupper',
        route: 'sso-groups',
      },
      active: false,
    },
  ];
}

interface NavItem {
  link: {
    label: string;
    route: string;
  };
  active: boolean;
}
